import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Target, Users, Shield } from 'lucide-react';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      
      {/* Hero */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h1 
            className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold"
            style={{ color: 'var(--hr-text)' }}
          >
            À propos d'Homely Rénovation
          </h1>
          <p 
            className="text-xl leading-relaxed"
            style={{ color: 'var(--hr-text-muted)' }}
          >
            Nous sommes une activité de Homely Solutions, spécialisée dans le pilotage de rénovations intérieures en Suisse romande.
          </p>
        </div>
      </section>

      {/* Vision */}
      <section className="py-12 sm:py-16">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            
            {/* Notre constat */}
            <div className="space-y-4">
              <h2 className="font-['Playfair_Display'] text-3xl font-semibold" style={{ color: 'var(--hr-text)' }}>
                Notre constat
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
                Les rénovations sont souvent source de stress : artisans multiples, planning qui dérape, imprévus, manque de suivi. Le client se retrouve à tout coordonner seul, sans expérience.
              </p>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
                Résultat : une expérience chaotique, un résultat décevant, et un coût qui explose.
              </p>
            </div>

            {/* Notre approche */}
            <div className="space-y-4">
              <h2 className="font-['Playfair_Display'] text-3xl font-semibold" style={{ color: 'var(--hr-text)' }}>
                Notre approche
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
                Homely Rénovation propose une alternative : un pilotage complet de votre projet de rénovation intérieure.
              </p>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
                Nous coordonnons les artisans, suivons le planning, contrôlons la qualité, anticipons les imprévus. Vous avez un seul interlocuteur, un cadre clair, et un résultat garanti.
              </p>
            </div>

            {/* Valeurs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6">
              {[
                {
                  icon: Target,
                  title: 'Clarté',
                  desc: 'Devis précis, planning tenu, réception propre'
                },
                {
                  icon: Shield,
                  title: 'Qualité',
                  desc: 'Contrôles réguliers, finitions soignées'
                },
                {
                  icon: Users,
                  title: 'Sérénité',
                  desc: 'Vous déléguez, nous gérons'
                }
              ].map((value, i) => (
                <Card key={i} className="rounded-2xl border-[color:var(--hr-border)] text-center">
                  <CardContent className="p-6 space-y-4">
                    <div className="mx-auto h-12 w-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
                      <value.icon className="h-6 w-6" style={{ color: 'var(--hr-primary)' }} />
                    </div>
                    <h3 className="font-['Figtree'] text-lg font-semibold" style={{ color: 'var(--hr-text)' }}>
                      {value.title}
                    </h3>
                    <p className="text-sm" style={{ color: 'var(--hr-text-muted)' }}>
                      {value.desc}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-['Playfair_Display'] text-3xl font-semibold" style={{ color: 'var(--hr-text)' }}>
            Prêt à lancer votre projet ?
          </h2>
          <Button
            size="lg"
            className="rounded-xl px-8"
            style={{ backgroundColor: 'var(--hr-primary)', color: 'var(--hr-primary-fg)' }}
            onClick={() => navigate('/devis')}
          >
            Demander un devis
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>
    </div>
  );
}